import Storefront from './index';
import * as queries from './queries';
import { formatBundle } from './format-resource';

const getBundleValue = async (id) => {
  const storefront = new Storefront();
  const response = await storefront.request({
    query: queries.bundleGet(id),
    variables: {
      countryCode: window.TMW.localization.countryCode,
    },
  });
  if (response.errors) return console.error(response.errors);
  const formattedBundle = formatBundle(response.data.products);
  return formattedBundle?.value;
};

export default getBundleValue;
